import axios from 'axios';
import {
  type BrokerageFirmGenerateDocumentUploadUrlInputBody,
  brokerageFirmControllerGenerateUploadDocumentUrl,
  buildSignedUploadHeaders,
  toKeyValueFields,
} from '../';

export async function uploadDocumentsOnBrokerageFirm({
  brokerageFirmId,
  payload,
}: {
  brokerageFirmId: string;
  payload: Omit<BrokerageFirmGenerateDocumentUploadUrlInputBody, 'metadata'> & {
    file: File;
    metadata: Record<string, string>;
  };
}): Promise<{ key: string }> {
  const { file, ...rest } = payload;

  const { url, id, contentType, contentDisposition } =
    await brokerageFirmControllerGenerateUploadDocumentUrl(brokerageFirmId, {
      ...rest,
      metadata: toKeyValueFields(rest?.metadata ?? []),
    } as BrokerageFirmGenerateDocumentUploadUrlInputBody);

  const headers = buildSignedUploadHeaders({
    contentType,
    contentDisposition,
    filename: payload.name,
    fallbackContentType: payload.file.type,
  });

  await axios.put(url, payload.file, { headers });

  return { key: id };
}
